import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCcH0RYpxvEovMwlS-1D7bdc65Scxo2vrc",
  authDomain: "finance-96d92.firebaseapp.com",
  projectId: "finance-96d92",
  storageBucket: "finance-96d92.appspot.com", // ✅ corrected
  messagingSenderId: "1082261744563",
  appId: "1:1082261744563:web:97438f4c003431abcc39c6"
};

const vapidKey = "BF0aNLqLOdNO9ddDj13mJbIqsQjpV-Ixv7FMXUZJ8NN8LHIv-RsJym7rZn6QXm2ECyCkVoDcjMPEccGG30vaj8I";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return null;
    }

    const swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    });

    console.log("📲 FCM Token:", token);
    return token;
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
    return null;
  }
};

export const listenToForegroundMessages = () => {
  onMessage(messaging, (payload) => {
    console.log("💬 Foreground message received:", payload);
    if (payload?.notification) {
      alert(`📢 ${payload.notification.title}: ${payload.notification.body}`);
    }
  });
};
